<template>
    <div class="col-12">
        <calendar-controls ref="calendarControls" @reloaded="settingsReloaded">
        </calendar-controls>

        <div class="form-group">
            <div class="input-group col-sm-12 col-md-6 float-left">
                <div class="col-3 pl-0">
                    <button class="btn btn-secondary"
                            @click.stop="reload">
                        <i class="fas fa-sync"></i>
                        {{ $t('buttons.reload.btnText') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="clearfix">
        </div>

        <div class="col-12">
            <kendo-schedulerdatasource ref="calendarDataSource"
                                       :transport="calendarTransportSettings"
                                       :server-filtering="true"
                                       :schema-model-id="'id'"
                                       :schema-model-fields="scheduleSchemaModelFields"
                                       :error="dataSourceError"
                                       :typeof="'odata-v4'"
                                       :requestEnd="datasorceRequestEnd">
            </kendo-schedulerdatasource>

            <kendo-scheduler ref="scheduler"
                             data-source-ref="calendarDataSource"
                             :date="initialDate"
                             :auto-bind="false"
                             :start-time="startWorkingTime"
                             :end-time="endWorkingTime"
                             :all-day-slot="allDaySlot"
                             :timezone="'Europe/Sofia'"
                             :pdf-file-name="pdfExportFileName"
                             :views="schedulerViews"
                             :editable="false"
                             :mobile="true"
                             :event-template="itemTemplate"
                             :id="'scheduler'"
                             :data-bound="dataBound">
            </kendo-scheduler>
        </div>

        <event-display-modal :value="eventDisplayModel" :show="showEventDisplay" @onClose="onEventDisplayClose"></event-display-modal>
        <task-display-modal :value="taskDisplayModel" :show="showTaskDisplay" @onClose="onTaskDisplayClose"></task-display-modal>
    </div>

</template>

<script>
    import Vue from 'vue';
    import $ from 'jquery';
    import moment from 'moment';
    import { SchedulerInstaller } from '@progress/kendo-scheduler-vue-wrapper'
    import { Culture } from '@/models/enums';
    import CalendarControls from '@/components/calendar/CalendarControls';
    import EventDisplayModal from '@/components/calendar/EventDisplayModal';
    import TaskDisplayModal from '@/components/tasks/display.modal';

    Vue.use(SchedulerInstaller)

    export default {
        components: {
            CalendarControls,
            EventDisplayModal,
            TaskDisplayModal
        },
        props: {
            viewType: {
                required: true,
                type: String,
            },
            defaultTypeId: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                name: 'Calendar',
                scheduleTask: null,
                typeId: this.defaultTypeId,
                initialDate: new Date(),
                startWorkingTime: new Date("2019/11/13 07:00 AM"), // Начален час на показване // new Date(this.initialDate.getFullYear(), this.initialDate.getMonth(), this.initialDate.getDate(), 7, 0, 0),
                endWorkingTime: new Date("2019/11/13 08:00 PM"), // Краен час на показване // new Date(this.initialDate.getFullYear(), this.initialDate.getMonth(), this.initialDate.getDate(), 7, 0, 0),
                allDaySlot: true,
                pdfExportFileName: "Scheduler_Export.pdf",
                showEventDisplay: false,
                eventDisplayModel: null,
                showTaskDisplay: false,
                taskDisplayModel: null,
                calendarTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/calendar/loadItems/`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                scheduleSchemaModelFields: {
                    id: { name: 'id', from: 'id', type: "number" },
                    eventId: { name: 'eventId', from: 'eventId', type: "number", nullable: true },
                    title: { name: 'title', from: 'title', type: "string", nullable: true },
                    description: { name: 'description', from: 'description', type: "string", nullable: true },
                    eventName: { name: 'eventName', from: 'eventName', type: "string", nullable: true },
                    start: { name: 'start', from: 'start', type: "date", nullable: true },
                    end: { name: 'end', from: 'end', type: "date", nullable: true },
                    isEvent: { name: 'isEvent', from: 'isEvent', type: "boolean" },
                    isTask: { name: 'isTask', from: 'isTask', type: "boolean" },
                    isOrganizationalTask: { name: 'isOrganizationalTask', from: 'isOrganizationalTask', type: "boolean" },
                    color: { name: 'color', from: 'color', type: "string", nullable: true },
                },
                itemTemplate: '<div class="d-inline-block text-truncate" style="max-width: 13rem; color: black" title="Заглавие: #: title # \n Име на събитие: #: eventName # \n Описание: #: description # \n Интервал: #: kendo.toString(start, "hh:mm") # - #: kendo.toString(end, "hh:mm") # "><p style="font-size: 14px">#: title #</p><p style="font-size: 12px">#: eventName #</p></div>',
                schedulerViews: [
                    { type: "day", selected: this.isInView('day') },
                    { type: "workWeek", selected: this.isInView('workWeek') },
                    { type: "week", selected: this.isInView('week') },
                    { type: "month", selected: this.isInView('month') },
                    { type: "agenda", selected: this.isInView('agenda') }
                ],
            }
        },
        methods: {
            dataBound(e) {
                const scheduler = this.$refs.scheduler.kendoWidget();
                if (!scheduler) {
                    return;
                }

                let view = scheduler.view();
                let items = scheduler.dataSource.view();
                var itemElement;
                var item;

                for (var idx = 0, length = items.length; idx < length; idx++) {
                    item = items[idx];

                    // get event element
                    itemElement = view.element.find("[data-uid=" + item.uid + "]");

                    // set the backgroud of the element
                    itemElement.css("background-color", item.color);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    let range = this.getTimeRange();
                    let calendarUserSettings = this.getCalendarUserSettings()
                    let newOptions = { request: options, range: range, settings: calendarUserSettings };
                    return kendo.stringify(newOptions);
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === "read" && e.response) {

                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            reload() {
                this.$refs.calendarDataSource.kendoWidget().read();
                // this.$refs.scheduler.kendoWidget().refresh();
            },
            isInView(val) {
                return this.viewType === val;
            },
            getTimeRange() {
                const scheduler = this.$refs.scheduler.kendoWidget();
                if (!scheduler) {
                    return {};
                }

                let startDate;
                let endDate;
                let timezone = scheduler.options.timezone;
                if (timezone) {
                    startDate = kendo.timezone.convert(scheduler.view().startDate(), timezone, "Etc/UTC");
                    endDate = kendo.timezone.convert(scheduler.view().endDate(), timezone, "Etc/UTC");
                } else {
                    startDate = scheduler.view().startDate();
                    endDate = scheduler.view().endDate();
                }

                let startTime = 0;
                let endTime = 0;

                if (scheduler.view().startTime) {
                    // optionally add startTime / endTime of the view
                    startTime = kendo.date.getMilliseconds(scheduler.view().startTime());
                    endTime = kendo.date.getMilliseconds(scheduler.view().endTime());
                    endTime = endTime === 0 ? kendo.date.MS_PER_DAY : endTime;
                }

                let result = {
                    Start: new Date(startDate.getTime() - (startDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + startTime),
                    End: new Date(endDate.getTime() - (endDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + endTime)
                }

                return result;
            },
            getCalendarUserSettings() {
                let calendarControls = this.$refs.calendarControls;
                if (calendarControls) {
                    return calendarControls.calendarUserSettings();
                }

                return {};
            },
            settingsReloaded() {
                this.reload();
            },
            eventDoubleClicked(e) {
                let scheduler = this.$refs.scheduler.kendoWidget();
                var element = $(e.target).is(".k-event") ? $(e.target) : $(e.target).closest(".k-event");
                var item = scheduler.occurrenceByUid(element.data("uid"));

                if (item.isEvent) {
                    this.loadEventModel(item.id);
                } else if (item.isTask) {
                    this.loadTaskModel(item.id);
                }
            },
            taskDoubleClicked(e) {
                let scheduler = this.$refs.scheduler.kendoWidget();
                var element = $(e.target).is(".k-task") ? $(e.target) : $(e.target).closest(".k-task");
                var item = scheduler.occurrenceByUid(element.data("uid"));

                if (item.isEvent) {
                    this.loadEventModel(item.id);
                } else if (item.isTask) {
                    this.loadTaskModel(item.id);
                }
            },
            onEventDisplayClose() {
                this.showEventDisplay = false;
                this.eventDisplayModel = null;
            },
            onTaskDisplayClose() {
                this.showTaskDisplay = false;
                this.taskDisplayModel = null;
            },
            loadEventModel(id) {
                this.$http.get(`/api/events/${id}/details`).then(result => {
                    if (result.data) {
                        this.eventDisplayModel = result.data;
                        this.showEventDisplay = true;
                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            loadTaskModel(id) {
                this.$http.get(`/api/tasks/${id}`).then(result => {
                    if (result.data) {
                        this.taskDisplayModel = result.data;
                        this.showTaskDisplay = true;
                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            }
        },
        mounted() {
            // add listener to a scheduler item doubl click
            $("#scheduler").on('dblclick', '.k-event', this.eventDoubleClicked);
            $("#scheduler").on('dblclick', '.k-task', this.taskDoubleClicked);

            $("#scheduler").kendoTooltip({
                filter: "td[role='gridcell']",
                width: 400,
                autoHide: false,
                showOn: 'click',
                content: function (e) {
                    var scheduler = $("#scheduler").getKendoScheduler();
                    var slot = scheduler.slotByElement(e.target);
                    var events = scheduler.occurrencesInRange(slot.startDate, slot.endDate);
                    var content = "";
                    for (var i = 0; i < events.length; i++) {
                        let item = events[i];
                        if (item.isOrganizationalTask) {
                            content = content + '<div><i class="fas fa-tasks ml-2 mr-2" style="color: ' + item.color + ';"></i><em>' + item.title + '</em> / ' + item.description + '</div><hr />';
                        } else if (item.isTask && !item.isOrganizationalTask) {
                            content = content + '<div><i class="fas fa-tasks ml-2 mr-2" style="color: ' + item.color + ';"></i><em>' + item.title + '</em> / ' + item.description + '</div><hr />';
                        } else if (item.isEvent) {
                            content = content + '<div><i class="fas fa-university ml-2 mr-2" style="color: ' + item.color + ';"></i><em>' + item.title + '</em> / ' + item.description + '</div><hr />';
                        }
                    }

                    let template = '<div class="card bg-white text-dark">'
                        + '<div class="card-header">'
                        + '<h5 class="text-center">' + kendo.htmlEncode(moment(slot.startDate).format('DD.MMM.YYYY')) + '</h5>'
                        + '</div>'
                        + '<div class="card-body">'
                        + (content === "" ? this.$t('missingData') : content)
                        + '</div>'
                        + '</div>';
                    return template;
                }.bind(this)
            });
        },
        beforeDestroy() {
            // remove listener
            $("#scheduler").off('dblclick', '.k-event');
            $("#scheduler").off('dblclick', '.k-task');
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            hasEditRights() {
                return this.$store.getters.claims.calendar.create
                    || his.$store.getters.claims.calendar.update;
            },
        }

    }
</script>

<style scoped>
    .invalid-slot {
        background: red !important;
        cursor: no-drop;
    }

    /* Hide toolbar, navigation and footer during export */
    .k-pdf-export .k-scheduler-toolbar,
    .k-pdf-export .k-scheduler-navigation .k-nav-today,
    .k-pdf-export .k-scheduler-navigation .k-nav-prev,
    .k-pdf-export .k-scheduler-navigation .k-nav-next,
    .k-pdf-export .k-scheduler-footer {
        display: none;
    }

    /*increase the height of the cells in day, work week and week views*/
    /*.k-scheduler-table td, .k-scheduler-table th {
        height: 5.5em;
    }*/

    /*increase the height of the month view cells*/
    /*.k-scheduler-monthview .k-scheduler-table td {
        height: 15.5em;
    }*/

    @media print {
        .k-scheduler,
        .k-scheduler-content,
        .k-scheduler-times {
            height: auto !important;
        }

        .k-scheduler-content {
            overflow-y: scroll !important;
        }
    }
</style>
